module.exports = __webpack_public_path__ + "img/ensineme.f2cf27b4.png";